module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-sm-center"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('form', {
    staticClass: "shaded",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.processForm($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.$v.form.companyName.$error
    }
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        Company name\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.companyName),
      expression: "form.companyName"
    }],
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.form.companyName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "companyName", $event.target.value)
      }, _vm.$v.form.companyName.$touch]
    }
  })]), _vm._v(" "), (_vm.$v.form.companyName.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.form.companyName.required) ? _c('span', [_vm._v("Company name is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.companyName.minLength) ? _c('span', [_vm._v("Your company name must have at least 3 characters.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.salesChannels) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Sales channel")]), _vm._v(" "), _c('vSelect', {
    attrs: {
      "label": "description",
      "options": _vm.salesChannels,
      "placeholder": "Pick a sales channel ...",
      "searchable": false
    },
    on: {
      "input": _vm.updateSalesChannel
    },
    model: {
      value: (_vm.selectedSalesChannel),
      callback: function($$v) {
        _vm.selectedSalesChannel = $$v
      },
      expression: "selectedSalesChannel"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('location-fields', {
    on: {
      "locationFieldsChanged": _vm.updateLocationFields
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'auth.signup.agent.create'
      }
    }
  }, [_c('input', {
    staticClass: "btn tertiary widest full",
    attrs: {
      "type": "button",
      "value": "Back"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    staticClass: "btn blue widest full",
    class: {
      'opacity-50': _vm.submittingRegistration
    },
    attrs: {
      "type": "submit",
      "value": "Submit",
      "disabled": !_vm.$v.form.$dirty || _vm.$v.form.$error
    }
  })])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signup-header row border-bottom-light row justify-content-sm-center"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h5', {
    staticClass: "color-1"
  }, [_vm._v("2. Your company")]), _vm._v(" "), _c('h2', [_vm._v("One more step.")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-1d5f2322", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d5f2322"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/agent/Step3.vue
// module id = 1628
// module chunks = 0